import React from 'react';

const Canada = (props: { width: number }) => {
  return (
    <svg viewBox="0 0 1000 500" {...props}>
      <title>Canadian Flag</title>
      <path d="M0 0h1000v500H0z" fill="red" />
      <path d="M250 0h500v500H250z" fill="#fff" />
      <path
        d="M499.992 46.875L465.88 110.5c-3.87 6.915-10.806 6.274-17.742 2.412l-24.697-12.789 18.408 97.727c3.87 17.854-8.55 17.854-14.678 10.135l-43.101-48.251-6.998 24.503c-.806 3.217-4.354 6.597-9.677 5.792l-54.502-11.459 14.315 52.045c3.065 11.58 5.455 16.375-3.093 19.43l-19.426 9.13 93.82 76.208c3.714 2.882 5.59 8.067 4.268 12.762l-8.21 26.947c32.303-3.724 61.248-9.326 93.568-12.776 2.854-.305 7.63 4.404 7.61 7.71l-4.28 98.724h15.707l-2.472-98.512c-.02-3.306 4.313-8.227 7.166-7.922 32.32 3.45 61.266 9.052 93.57 12.776l-8.211-26.947c-1.322-4.695.554-9.88 4.267-12.762l93.822-76.208-19.427-9.13c-8.548-3.055-6.158-7.85-3.093-19.43l14.315-52.045-54.502 11.46c-5.323.804-8.87-2.576-9.677-5.793l-6.998-24.503-43.1 48.25c-6.13 7.72-18.55 7.72-14.679-10.134l18.407-97.727-24.696 12.789c-6.936 3.862-13.871 4.503-17.742-2.412"
        fill="red"
      />
    </svg>
  );
};

export default Canada;
